import axios from 'axios'
import {API_ADMIN} from '@/utils/constants/Api'
import {DeliveryCompanyModel} from '@/delivery_company/models/DeliveryCompanyModel'
import { BaseAssociableEntity, BaseChannelBackendAssociation } from '@c2b/muven-commons'
import { IEntityAssociation } from '../../utils/interfaces/EntityAssociationInterface'
import { IFilterList } from '../../utils/interfaces/FilterListInterface'

class DeliveryCompanyService implements IEntityAssociation {
    getDeliveryCompanies(page:number, filter:IFilterList):Promise<DeliveryCompanyModel[]> {
        return axios.get(`${API_ADMIN}delivery_companies?page=${page}${filter.toPartialQueryString()}`)
            .then(({data}) => {
                return data.map((c:DeliveryCompanyModel) => {
                    return new DeliveryCompanyModel(c)
                })
            })
    }

    getDeliveryCompanyById(id:number):Promise<DeliveryCompanyModel> {
        return axios.get(`${API_ADMIN}delivery_companies/${id}`)
            .then(({data}) => {
                return new DeliveryCompanyModel(data)
            })
    }

    getEntitiesInBackend(channelId:number):Promise<BaseAssociableEntity[]> {
        return axios.get(`${API_ADMIN}delivery_companies/in_muven/from_channel/${channelId}`)
            .then(({data}) => {
                return data.map((b:BaseAssociableEntity) => new BaseAssociableEntity(b))
            })
    }

    getEntitiesInChannel(channelId:number):Promise<BaseAssociableEntity[]> {
        return axios.get(`${API_ADMIN}delivery_companies/in_channel/${channelId}`)
            .then(({data}) => {
                return data.map((b:BaseAssociableEntity) => new BaseAssociableEntity(b))
            })
    }

    associateChannelEntitiesWithBackendEntities(associationList:BaseChannelBackendAssociation[], channelId:number):Promise<any> {
        return axios.post(`${API_ADMIN}delivery_companies/association/in_channel/${channelId}`, associationList)
            .then(({data}) => {
                return data
            })    
    }

    updateAllowExportInDeliveryCompany(idDeliveryCompany: number, allowExport:boolean):Promise<any> {
        return axios.patch(`${API_ADMIN}delivery_companies/${idDeliveryCompany}/allow_export/${allowExport}`)
            .then(({data}) => {
                return data
            })
    }

    updateAllowExportInDeliveryCompanyChannel(idDeliveryCompanyChannel: number, allowExport:boolean):Promise<any> {
        return axios.patch(`${API_ADMIN}delivery_companies/channel/allow_export/${idDeliveryCompanyChannel}/${allowExport}`)
            .then(({data}) => {
                return data
            })
    }
}

export default new DeliveryCompanyService()

